import type { Advisor } from "@verde/entities";
import { SearchIcon } from "@verde/icons";
import { Client, useAuthContext } from "@verde/modules";
import { Alert } from "@verde/ui-core";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useCreditProfilePanel } from "./panel";
import { PanelSearchClientHistory } from "./panel-search-client-history";

function PanelSearchClient() {
  const { user } = useAuthContext<Advisor>();
  const { client, options, setClient, onSearchClient } =
    useCreditProfilePanel();

  const { control, setValue } = useForm({
    defaultValues: {
      document_number: "",
    },
  });

  useEffect(() => {
    if (client?.document_number) {
      setValue("document_number", client.document_number);
    }
  }, [client?.document_number, setValue]);

  return (
    <div className="grid gap-4">
      <div className="grid gap-6 rounded border border-neutral-light-2 p-4">
        <Client.SearchField
          control={control}
          name="document_number"
          onFound={(client) => {
            onSearchClient?.(client);
            setClient(client);
          }}
          inputProps={{
            addon: <SearchIcon />,
          }}
          mode={user?.kind === "ADVISOR" ? "cpf" : "both"}
        />

        {options?.has_history && <PanelSearchClientHistory />}
      </div>

      {!client?.id && (
        <Alert
          kind="info"
          classNames={{
            base: "px-6 py-4",
            content: "flex items-center gap-4",
          }}
        >
          <img
            alt="Ícone de uma lupa nas nuvens"
            src="/static/icons/cloud-search.png"
            className="h-8 w-8 object-contain"
          />

          <p className="text-lg font-medium text-neutral-dark-2">
            Os detalhes do CPF/CNPJ do cliente consultado serão apresentados
            aqui.
          </p>
        </Alert>
      )}
    </div>
  );
}

export default React.memo(PanelSearchClient);
